export type PollingState = {
  isPolling: boolean;
  pollCount: number;
  timeoutId?: ReturnType<typeof setTimeout> | undefined;
};

export const INITIAL_DELAY = 30000;
export const POLLING_INTERVAL = 10000;
export const MAX_POLLING_DURATION = 180000;

type RawArtworkResponse = {
  id: number | string;
  current_enhancement_state?: string;
  currentEnhancementState?: string;
  ordered?: {
    image_url?: string;
    imageUrl?: string;
    no_bg_url?: string;
    noBgUrl?: string;
    no_bg_no_trim_url?: string;
    noBgNoTrimUrl?: string;
    with_bg_url?: string;
    withBgUrl?: string;
    manual_edit_url?: string;
    manualEditUrl?: string;
    manual_edit_no_trim_url?: string;
    manualEditNoTrimUrl?: string;
    can_remove_bg?: boolean;
    canRemoveBg?: boolean;
    remove_background?: boolean;
    removeBackground?: boolean;
    enhance_image?: boolean;
    enhanceImage?: boolean;
    enhancement_tier?: string;
    enhancementTier?: string;
    edit_image_manual?: boolean;
    editImageManual?: boolean;
    metadata?: { error?: string };
    enhanced_metadata?: unknown;
    enhancedMetadata?: unknown;
    original_metadata?: unknown;
    originalMetadata?: unknown;
    with_bg_metadata?: unknown;
    withBgMetadata?: unknown;
  };
  original?: {
    image_url?: string;
    imageUrl?: string;
  };
};

export type NormalizedArtwork = {
  id: string;
  url: string;
  imageUrl: string;
  originalImageUrl: string;
  withBgUrl: string;
  noBgUrl: string;
  noBgNoTrimUrl: string;
  manualEditUrl: string | null;
  manualEditNoTrimUrl: string | null;
  canRemoveBg: boolean;
  removeBackground: boolean;
  enhanceImage: boolean;
  enhancementTier: string;
  editImageManual: boolean;
  currentEnhancementState: string | undefined;
  metadata: { error?: string } | undefined;
  enhancedMetadata: unknown;
  originalMetadata: unknown;
  withBgMetadata: unknown;
};

export function normalizeArtworkResponse(artwork: RawArtworkResponse): NormalizedArtwork {
  const { ordered, original } = artwork;

  const imageUrl = ordered?.image_url || ordered?.imageUrl || "";
  const noBgUrl = ordered?.no_bg_url || ordered?.noBgUrl || "";
  const originalImageUrl = original?.image_url || original?.imageUrl || imageUrl;

  return {
    id: String(artwork.id),
    url: noBgUrl || imageUrl,
    imageUrl,
    originalImageUrl,
    withBgUrl:
      ordered?.with_bg_url ||
      ordered?.withBgUrl ||
      original?.image_url ||
      original?.imageUrl ||
      imageUrl,
    noBgUrl,
    noBgNoTrimUrl: ordered?.no_bg_no_trim_url || ordered?.noBgNoTrimUrl || imageUrl,
    manualEditUrl: ordered?.manual_edit_url || ordered?.manualEditUrl || null,
    manualEditNoTrimUrl: ordered?.manual_edit_no_trim_url || ordered?.manualEditNoTrimUrl || null,
    canRemoveBg: ordered?.can_remove_bg ?? ordered?.canRemoveBg ?? true,
    removeBackground: ordered?.remove_background ?? ordered?.removeBackground ?? false,
    enhanceImage: ordered?.enhance_image ?? ordered?.enhanceImage ?? true,
    enhancementTier: ordered?.enhancement_tier || ordered?.enhancementTier || "full_enhancements",
    editImageManual: ordered?.edit_image_manual ?? ordered?.editImageManual ?? false,
    currentEnhancementState: artwork.current_enhancement_state || artwork.currentEnhancementState,
    metadata: ordered?.metadata,
    enhancedMetadata: ordered?.enhanced_metadata || ordered?.enhancedMetadata,
    originalMetadata: ordered?.original_metadata || ordered?.originalMetadata,
    withBgMetadata: ordered?.with_bg_metadata || ordered?.withBgMetadata
  };
}
